
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21.59 12.58C21.84 12.23 21.84 11.77 21.59 11.42L17.63 5.84001C17.27 5.33001 16.67 5.00001 16 5.00001H8.65999L19.36 15.73L21.59 12.58ZM2.71999 4.72001L3.58999 5.59001C3.22999 5.95001 2.99999 6.45001 2.99999 7.00001V17C2.99999 18.1 3.89999 19 4.99999 19H17L18.29 20.29C18.68 20.68 19.31 20.68 19.7 20.29C20.09 19.9 20.09 19.27 19.7 18.88L4.13999 3.31001C3.75999 2.93001 3.12999 2.92001 2.73999 3.30001C2.32999 3.68001 2.32999 4.33001 2.71999 4.72001Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-label-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconLabelOff

    ```js
    <b-new-b-icon-label-off />
    ```
</docs>


